import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';
import { shuffle } from 'lodash';
import { Answer, Option, Question, Test } from '../socio-emotional-skills-test.models';
import Swal from 'sweetalert2';


@Component({
  selector: 'app-socio-emotional-skills-test-question-runner',
  templateUrl: './socio-emotional-skills-test-question-runner.component.html',
  styleUrls: ['./socio-emotional-skills-test-question-runner.component.scss'],
  animations: [
    trigger('fadeSlide', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(20px)' }),
        animate('300ms ease-out', style({ opacity: 1, transform: 'translateY(0)' }))
      ])
    ])
  ]
})
export class SocioEmotionalSkillsTestQuestionRunnerComponent implements OnInit {

  @Input() test!: Test;
  @Output() finished = new EventEmitter<Answer[]>();

  currentIndex = 0;
  answers: Answer[] = [];
  shuffledOptions: Option[] = [];

  ngOnInit(): void {
    this.shuffleCurrentOptions();
  }

  get currentQuestion(): Question {
    return this.test.questions[this.currentIndex];
  }

  shuffleCurrentOptions(): void {
    this.shuffledOptions = shuffle([...this.currentQuestion.options]);
  }

  selectOption(optionId: string): void {
    const questionId = this.currentQuestion._id;
    const existing = this.answers.find(a => a.questionId === questionId);

    if (existing) {
      existing.selectedOptionId = optionId;
    } else {
      this.answers.push({ questionId, selectedOptionId: optionId });
    }
  }

  isOptionSelected(optionId: string): boolean {
    const answer = this.answers.find(a => a.questionId === this.currentQuestion._id);
    return answer?.selectedOptionId === optionId;
  }

  next(): void {

    if (this.currentIndex < this.test.questions.length - 1) {
      this.currentIndex++;
      this.shuffleCurrentOptions();
    } else {
      this.handleFinishTest();
    }
  }

  handleFinishTest(): void {
    Swal.fire({
      title: '¿Deseas finalizar el test?',
      text: 'Una vez finalices, no podrás modificar tus respuestas.',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#545ba8',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí, enviar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        this.finished.emit(this.answers);
      }
    }); 
  }

  isCurrentAnswered(): boolean {
    return this.answers.some(a => a.questionId === this.currentQuestion._id);
  }
}
